import { Components } from '@mui/material'

const MuiIconButton: Components['MuiIconButton'] = {
  styleOverrides: {
    root: {
      variants: [
        {
          props: { color: 'bordered' },
          style: ({ theme }) => ({
            border: '1px solid',
            borderColor: theme.palette.grey[300],
            color: theme.palette.grey[800],
          }),
        },
        {
          props: { color: 'primary' },
          style: ({ theme }) => ({
            color: theme.palette.primary.light,
          }),
        },
        {
          props: { color: 'info' },
          style: ({ theme }) => ({
            color: theme.palette.grey[500],
            backgroundColor: theme.palette.grey[100],
          }),
        },
        {
          props: { color: 'fill' },
          style: ({ theme }) => ({
            color: theme.palette.common.white,
            backgroundColor: theme.palette.grey[400],
            '&:hover': {
              backgroundColor: theme.palette.grey[300],
            },
          }),
        },
      ],
    },
  },
}

export default MuiIconButton
